module.exports = __webpack_public_path__ + "static/media/login-background.7be6e01c.jpg";